import { isEmpty, isNaN, isNumber, toNumber, trim } from 'lodash';

export const MAX_INT_32 = 2147483647;

export function validateTargetSharePrice(
  price: string | number,
  currentPrice?: number
) {
  if (isEmpty(price) && !isNumber(price)) {
    return false;
  }

  if (typeof price === 'string' && isEmpty(trim(price))) {
    return false;
  }

  const parsedPrice = toNumber(price);
  if (!isNumber(parsedPrice) || isNaN(parsedPrice)) {
    return false;
  }

  if (parsedPrice <= 0) {
    return false;
  }

  const maxLimit =
    currentPrice && currentPrice * 100 <= MAX_INT_32
      ? currentPrice * 100
      : MAX_INT_32;

  if (parsedPrice > maxLimit) {
    return false;
  }

  return true;
}
